import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { CapturistasService } from './services/capturistas.service';
import { ICapturistaListRequest, ICapturistaListItem } from './interfaces/capturistas.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-capturistas',
  templateUrl: './capturistas.component.html',
  providers: [MessageService]
})
export class CapturistasComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedCapturista: ICapturistaListItem | null = null;
  dataSource: ICapturistaListItem[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'susuario', header: 'Clave Capturista', sortable: true },
    { field: 'nombre', header: 'Nombre', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private capturistasService: CapturistasService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    const payload: ICapturistaListRequest = {
      que: 4,
      tope: '999',
      cmd: '',
      clave_capturista: '',
      nombre: ''
    };
    this.capturistasService.getCapturistasList(payload).subscribe({
      next: (response) => {
        this.dataSource = response.data;
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        console.error('Error al cargar capturistas:', error);
      }
    });
  }

  openCreate(): void {
    this.selectedCapturista = null;
    this.displayDialog = true;
  }

  openUpdate(row: ICapturistaListItem): void {
    this.selectedCapturista = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: ICapturistaListItem): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este capturista?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.capturistasService.deleteCapturista(row.susuario).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Capturista eliminado correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el capturista'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el capturista'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedCapturista = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(event: { success: boolean; message: string }): void {
    if (event.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: event.message
      });
      this.displayDialog = false;
      this.loadData();
    }
  }
} 